import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin({
  name: "ckweb:user",
  enforce: "pre",
  dependsOn: ["ckweb:auth", "ckweb:dev-console"],
  async setup($nuxt) {
    const { guardKleanzAccount } = useCrossAppGuard();
    const { refreshCurrentUser } = useAuthApi();
    const organizationStore = useOrganizationStore();

    $nuxt.$auth.addEventCallback(async (event) => {
      switch (event.type) {
        case "auth-account-found":
        case "auth-login-success": {
          devConsole.info("🔒 ckAuth: loading user");
          await refreshCurrentUser();
          organizationStore.refreshCurrentOrganization();
          break;
        }
      }
    });

    $nuxt.hook(
      "ckauth:ticket-redeemed",
      async ({ ticketResponse, sourceAppName }) => {
        devConsole.log("🔔  ckauth:ticket-redeemed hook triggered");
        await Promise.all([
          refreshCurrentUser(),
          organizationStore.refreshCurrentOrganization(),
        ]);

        const redirectResult = guardKleanzAccount({
          organizationExistsInKleanz:
            !!ticketResponse.account.downstreamOrganizationId,
          userExistsInKleanz: ticketResponse.account.userExistsInKleanz,
          canEnableApps: ticketResponse.account.canEnableApps,
          sourceAppName,
        });

        if (typeof redirectResult === "string") {
          $nuxt.runWithContext(() => navigateTo(redirectResult));
        }
      },
    );

    $nuxt.hook("ckauth:user-cleared", () => {
      devConsole.log("🔔  ckauth:cleared hook triggered");
      organizationStore.resetCurrentOrganization();
    });

    $nuxt.hook("ckauth:logout", () => {
      devConsole.log("🔔  ckauth:logout hook triggered");
      organizationStore.resetCurrentOrganization();
    });
    devConsole.info("🛠️ ckSetup: user hooked  🚀🚀🚀🚀🚀");
  },
});
